<template>
    <div class="selected-ages-area pt-100 pb-70" id="siniflarimiz">
        <div class="container">

            <div class="row">

                <div class="col-lg-3 col-sm-6 col-md-6" v-for="classItem of classes" :key="classItem.class_id">
                    <div class="single-selected-ages-box">
                        <div class="image">
                            <img :src="getImgUrl('siniflar', classItem.class_img)" alt="image">
                        </div>
                        <div class="content">
                            <h3>{{ classItem.class_header }}</h3>
                            <p>{{ classItem.class_content }}</p>
                            <span class="ages-number">{{ classItem.class_age }}</span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="kindergarten-shape15">
            <img src="../../assets/img/kindergarten-shape/k-shape15.png" alt="image">
        </div>
        <div class="kindergarten-shape16">
            <img src="../../assets/img/kindergarten-shape/k-shape16.png" alt="image">
        </div>
    </div>
</template>

<script>

import axios from "axios";

export default {

    name: 'ClassesList',
    props: ['pathUrl'],

    created() {
        this.getTitles();
        this.getAllClasses();
    },
    data() {
        return {
            titles: [],
            classes: [],
            errors: []
        };
    },
    methods: {
        getTitles() {
            axios
                .get(this.pathUrl + "?data=title&parent=7")
                .then(response => (this.titles = response.data.result))
                .catch(error => {
                    this.errors.push(error);
                });
        },
        getAllClasses() {
            axios
                .get(this.pathUrl + "?data=classes")
                .then(response => (this.classes = response.data.result))
                .catch(error => {
                    this.errors.push(error);
                });
        },
        getImgUrl(category, pet) {
            return require('../../../../assets/resimler/' + category + '/' + pet)
        }
    }
}


</script>